export const NotificationTypes = {
  APPOINTMENT_REQUESTED: 'APPOINTMENT_REQUESTED',
  APPOINTMENT_SCHEDULED: 'APPOINTMENT_SCHEDULED',
  APPOINTMENT_CONFIRMED: 'APPOINTMENT_CONFIRMED',
  APPOINTMENT_RESCHEDULED: 'APPOINTMENT_RESCHEDULED',
  APPOINTMENT_CANCELED: 'APPOINTMENT_CANCELED',
  PAYMENT_RECEIVED: 'PAYMENT_RECEIVED',
  APPOINTMENT_REMINDER: 'APPOINTMENT_REMINDER',
  CHAT_MESSAGE: 'CHAT_MESSAGE',
  MANAGER_NEW_GENERAL_REQUEST: 'MANAGER_NEW_GENERAL_REQUEST',
  MANAGER_NEW_REQUEST: 'MANAGER_NEW_REQUEST',
  MANAGER_APPOINTMENT_SCHEDULED: 'MANAGER_APPOINTMENT_SCHEDULED',
  MANAGER_APPOINTMENT_CANCELED: 'MANAGER_APPOINTMENT_CANCELED',
} as const;

export type NotificationType =
  (typeof NotificationTypes)[keyof typeof NotificationTypes];

export const NotificationChannels = {
  SMS: 'SMS',
  EMAIL: 'EMAIL',
  PUSH: 'PUSH',
} as const;

export type NotificationChannel =
  (typeof NotificationChannels)[keyof typeof NotificationChannels];

export type NotificationPreference = {
  channels: NotificationChannel[];
  enabled: boolean;
};

export type NotificationPreferences = {
  [key in NotificationType]?: NotificationPreference;
};

export type FullNotificationPreferences = Required<NotificationPreferences>;

export type UpdateNotificationPreferencesPayload = {
  businessId?: string;
  preferences: {
    type: NotificationType;
    channels: NotificationChannel[];
  }[];
};
